import {React, useState, useEffect, useRef} from 'react';

import styles from './statistics.module.css'

import utils from '../../../utils/utils';
import constants from '../../../constants';
import api from '../../../routes/api.js'

import { useApiProvider } from '../../../providers/ApiProvider.js';
import { useLeagueTypeProvider } from '../../../providers/LeagueTypeProvider';

import InfoDialog from '../../common/InfoDialog/InfoDialog.js';

import Table from "../../common/Table/Table.js"

const Statistics = ({selectedDivision, matchupId, players, genderPlayers, teamStatistics, homeClub, awayClub, homeTeam, awayTeam}) => {
  
  const { setDialog, LoadingSpinner } = useApiProvider();

  const { leagueType } = useLeagueTypeProvider();
  
  const [width, setWidth] = useState(window.innerWidth);
  
  const [teamStats, setTeamStats] = useState();
  const [awayPlayerStats, setAwayPlayerStats] = useState([]);
  const [homePlayerStats, setHomePlayerStats] = useState([]);
  const [infoDialogText, setInfoDialogText] = useState({
    title: "",
    body: ""
  });

  const infoDialogRef = useRef(null);

  const intervalRef = useRef(null);
  const intervalStartedRef = useRef(false);

  const filterSelectedPlayers = (obj) => {
    const homeMales = obj.homeMales.filter(p => p.selected !== false);
    const homeFemales = obj.homeFemales.filter(p => p.selected !== false);
    const awayMales = obj.awayMales.filter(p => p.selected !== false);
    const awayFemales = obj.awayFemales.filter(p => p.selected !== false);
    
    return {
      home: [...homeMales, ...homeFemales],
      away: [...awayMales, ...awayFemales],
    };
  };

  const filterSelectedGenderPlayers = (obj) => {
    const homePlayers = obj.homePlayers.filter(p => p.selected !== false);
    const awayPlayers = obj.awayPlayers.filter(p => p.selected !== false);
    
    return {
      home: [...homePlayers],
      away: [...awayPlayers],
    };
  };

  const openInfoDialog = () => {
    if (infoDialogRef.current){
      infoDialogRef.current.style.display = 'flex';
      infoDialogRef.current.showModal();
    }
  }

  const closeInfoDialog = () => {
    if (infoDialogRef.current){
      infoDialogRef.current.style.display = 'none';
      infoDialogRef.current.close();
    }
  }

  const getPlayerStatsTableHeader = () => {
    return leagueType === constants.pages.genderLeagues 
      ? constants.table.genderResultCols(setInfoDialogText, openInfoDialog)
      : constants.table.playerResultCols(setInfoDialogText, openInfoDialog)
  }

  useEffect(() => {
    // Update the score every 5 minutes
    // if (!intervalStartedRef.current) {
    //   intervalRef.current = setInterval(() => {
    //     getResults();
    //   }, 300000);
    //   intervalStartedRef.current = true;
    // }

    // getResults();
    const selectedPlayers = leagueType === constants.pages.genderLeagues ? filterSelectedGenderPlayers(genderPlayers) : filterSelectedPlayers(players);

    selectedPlayers.home.forEach((p) => {
      p.fullName = p[constants.firstName] + " " + (p[constants.middleName] ? p[constants.middleName][0] + ". " : "") + p[constants.lastName];
    });
    selectedPlayers.away.forEach((p) => {
      p.fullName = p[constants.firstName] + " " + (p[constants.middleName] ? p[constants.middleName][0] + ". " : "") + p[constants.lastName];
    });

    selectedPlayers.home.sort((a, b) => {
      const nameA = a[constants.lastName].toUpperCase(); // ignore upper and lowercase
      const nameB = b[constants.lastName].toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      // names must be equal
      return 0;
    });
  
    selectedPlayers.away.sort((a, b) => {
      const nameA = a[constants.lastName].toUpperCase(); // ignore upper and lowercase
      const nameB = b[constants.lastName].toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      // names must be equal
      return 0;
    });

    setAwayPlayerStats(selectedPlayers.away);
    setHomePlayerStats(selectedPlayers.home);

    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  return (
    <div className={styles.Statistics}>
      
      <InfoDialog ref={infoDialogRef}
            dialogTitle={infoDialogText.title}
            dialogMessage={infoDialogText.body}
            closeDialog={closeInfoDialog}/>

      <div className={styles.ScoreHeader}>
        <div className={styles.Title}>Final Score</div>
        <div className={styles.ScoreContainer}>
          <div className={styles.Banner} style={{backgroundColor: `${awayClub[constants.color]}`}}>
            {awayTeam}
          </div>
          
          <div className={styles.Score}>
            <span className={styles.ScoreText}>{teamStatistics[constants.awayTeam][constants.api.finalScore]}</span>
            <div className={styles.Dash}>-</div>
            <span className={styles.ScoreText}>{teamStatistics[constants.homeTeam][constants.api.finalScore]}</span>
          </div>

          <div className={styles.Banner} style={{backgroundColor: `${homeClub[constants.color]}`}}>
            {homeTeam}
          </div>

        </div>
      </div>
             
      <div className={styles.TeamContainer}>
        <div className={styles.Subtitle}>Team Statistics</div>
        <div className={styles.TeamStats}>
          <div className={styles.TeamStatsHeader}>
            <div className={styles.HeaderText} style={{color:`${awayClub[constants.color]}`}}>{awayTeam}</div>
            <div className={styles.HeaderText}>VS</div>
            <div className={styles.HeaderText} style={{color:`${homeClub[constants.color]}`}}>{homeTeam}</div>
          </div>
          {leagueType === constants.pages.genderLeagues ? 
            constants.table.lineupGenderTeamStatsCols.map((row, i) => {
              return (
                <div key={row.value} className={styles.TeamStatsRow} style={{backgroundColor: `${i%2 == 0 ? constants.colors.cplGray : constants.colors.cplWhite}`}}>
                  <div className={styles.RowText}>{teamStatistics[constants.awayTeam][row.value]}</div>
                  <div className={styles.RowText}>{row.label}</div>
                  <div className={styles.RowText}>{teamStatistics[constants.homeTeam][row.value]}</div>
                </div>
              )
            })
          : constants.table.lineupTeamStatsCols.map((row, i) => {
            return (
              <div key={row.value} className={styles.TeamStatsRow} style={{backgroundColor: `${i%2 == 0 ? constants.colors.cplGray : constants.colors.cplWhite}`}}>
                <div className={styles.RowText}>{teamStatistics[constants.awayTeam][row.value]}</div>
                <div className={styles.RowText}>{row.label}</div>
                <div className={styles.RowText}>{teamStatistics[constants.homeTeam][row.value]}</div>
              </div>
            )
          })}
        </div>
      </div>

      <div className={styles.Subtitle} style={{borderTop: '2px solid rgb(0, 26, 82, 20%)', paddingBottom:'1em'}}>Player Statistics</div>
      <div className={styles.TableTitle} style={{color: awayClub[constants.color]}}>{awayTeam}</div>
      <div className={styles.TableContainer}>
        <Table 
          headers={getPlayerStatsTableHeader()} 
          defaultHeader={constants.lastName}
          headerColor={awayClub[constants.color]} 
          tableKeys={[constants.id]} 
          tableData={awayPlayerStats} 
          setTableData={setAwayPlayerStats}
          canSort={true}/>
      </div>
      


      <div className={styles.TableTitle} style={{color: homeClub[constants.color]}}>{homeTeam}</div>
      <div className={styles.TableContainer}>
        <Table 
          headers={getPlayerStatsTableHeader()} 
          defaultHeader={constants.lastName}
          headerColor={homeClub[constants.color]} 
          tableKeys={[constants.id]} 
          tableData={homePlayerStats} 
          setTableData={setHomePlayerStats}
          canSort={true}/>
      </div>
    </div>
  )
}

export default Statistics;